import { useContext } from 'react';
import { TextButton } from 't-lib-ui/widgets';
import { RouterContext, goTo } from 't-lib-ui/router';
import { getKeyHandler } from 't-lib-ui/structure';
import { getMode } from '../connector/auth';
import { useFeedQuota } from '../connector/feed-quota';
import './FeedQuotaCard.css';

// "You've reached the feed limit" card. Shown on Home (dismissable, pass onClose) and permanently at
// the top of the Account page. Anonymous users are nudged to sign up; logged-in users to free up room.
const FeedQuotaCard: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
  const routerCtx = useContext(RouterContext);
  const anon = getMode() == 'anon';
  const { max } = useFeedQuota();
  return (
    <div className="feedQuotaCard">
      {onClose && (
        <button
          type="button"
          className="feedQuotaCardClose flowFocussable sidewayFocus"
          tabIndex={0}
          aria-label="Dismiss"
          onClick={onClose}
          onKeyDown={getKeyHandler(onClose)}
        >&times;</button>
      )}
      <h2 className="feedQuotaCardTitle">You've reached the feed limit</h2>
      <p className="feedQuotaCardText">
        {anon
          ? `You're following the maximum of ${max} feeds in anonymous mode. Sign up for a free account to follow more and keep your feeds synced across all your devices.`
          : `You're following the maximum of ${max} feeds on your plan. Unfollow feeds you no longer read to make room for new ones.`}
      </p>
      <div className="feedQuotaCardFooter">
        {anon
          ? <TextButton label="Sign up" type="major" size="small" onClick={() => { window.location.href = '/signup'; }} />
          : <TextButton label="Manage feeds" type="major" size="small" onClick={() => goTo(routerCtx, '/a/myfeeds')} />}
      </div>
    </div>
  );
};

export default FeedQuotaCard;
